<div class="row align-items-center mb-1">
  <div class="{{labelClass}}">
    <span class="label">{{label}}</span>
  </div>
  <div class="{{class}}">
    <div class="d-flex align-items-center fake-input" [ngClass]="{'form-control': isFromControl}">
      <a href="#" (click)="navigateToTarget($event)">{{value}}</a>
    </div>
  </div>
</div>
